import React from "react";
import { ExemptionFormTypeEnum } from "../../../shared/enums/exemption-form-type-enum";
import DrivingExemptionPage from "./DrivingExemptionPage";
import { gnhDrivingExemptionForm } from "./DrivingExemptionPageSelector";
import FormContents from "./FormContents";

const GnhDrivingExemptionForm = () => {
    return (
        <DrivingExemptionPage selectedPage={gnhDrivingExemptionForm}>
            <FormContents formType={ExemptionFormTypeEnum.GNH} ></FormContents>
        </DrivingExemptionPage>
    );
}

export default GnhDrivingExemptionForm;